import type {
  LifeReadinessCategory,
  LifeReadinessQuestion,
  LifeReadinessSubcategory,
} from '@backrs_ui/common-ui';

import { useRegisterAgentContext } from '@backrs_ui/grow-ui/src/agentContext/useRegisterAgentContext';
import { appStrings } from '@backrs_ui/grow-ui/src/assets/appStrings';

const LEVEL_LABELS = appStrings.modules.lifeReadiness.questionTooltips.consolidated;

const LEVEL_TITLES: Record<number, string> = {
  1: LEVEL_LABELS.notYet.title,
  2: LEVEL_LABELS.early.title,
  3: LEVEL_LABELS.strong.title,
  4: LEVEL_LABELS.advanced.title,
};

export const useAgentContext = ({
  category,
  subcategoriesForCategory,
  questions,
  userLevelMap,
}: {
  category: LifeReadinessCategory;
  subcategoriesForCategory: LifeReadinessSubcategory[];
  questions: LifeReadinessQuestion[];
  userLevelMap: Record<string, number>;
}) => {
  const subcategoryIds = new Set(subcategoriesForCategory.map((subcategory) => subcategory.id));
  const questionsInCategory = questions.filter((question) =>
    subcategoryIds.has(question.life_survey_subcategory_id),
  );

  useRegisterAgentContext({
    kind: 'list',
    description: `The answers this student recorded for the "${category.name}" Life Readiness category. They belong to the student, not to whoever is reading them, and cannot be changed from here.`,
    data: {
      category: category.name,
      answers: questionsInCategory.map((question) => ({
        question: question.name,
        level: userLevelMap[question.id] ?? null,
        level_name: LEVEL_TITLES[userLevelMap[question.id]] ?? null,
      })),
    },
  });
};
